import React from 'react';
import { Autocomplete, AutocompleteProps, TextFieldProps } from '@mui/material';
import CustomTextField from './CustomTextField';
import { ReactComponent as ArrowDownIcon } from '../../assets/arrow-triangle-down.svg';
import { useTheme } from "@mui/material/styles";

interface CustomAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput'> {
	textFieldLabel?: string | JSX.Element;
	customTextFieldProps?: TextFieldProps;
	renderInput?: (params: any) => React.ReactNode;
}

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
	textFieldLabel,
	customTextFieldProps,
	renderInput,
	componentsProps,
	popupIcon,
	...rest
}) => {
	const theme= useTheme();
	const colors = theme.palette;
	return (
		<Autocomplete
			{...rest}
			sx={{
				'& .MuiAutocomplete-popupIndicator': {
					color: 'white.main'
				},
				'& .MuiAutocomplete-clearIndicator': {
					color: 'white.main'
				},
				'& .MuiInputBase-input.Mui-disabled': {
					WebkitTextFillColor: 'light.diff'
				},
				'& .MuiInputBase-root': {
					fontSize: '14px',
					fontWeight: '500'
				},
				...rest.sx
			}}
			componentsProps={{
				...componentsProps,
				paper: {
					...componentsProps?.paper,
					sx: {
						bgcolor: `${colors.dropdown.menuItemBackground} !important`,
						color: `${colors.dropdown.menuItemText} !important`,
						'& .MuiAutocomplete-option': {
							bgcolor: `${colors.dropdown.menuItemBackground} !important`,
							color: `${colors.dropdown.menuItemText} !important`,
							'& .MuiTypography-root': {  // <span> wrapper inside option
								color: `${colors.dropdown.menuItemText} !important`,
							},
							'&.Mui-selected': {
								backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
								color: `${colors.dropdown.menuItemHoverText} !important`,
								'& .MuiTypography-root': {  // <span> wrapper inside option
									color: `${colors.dropdown.menuItemHoverText} !important`,
								},
							},
							'&.Mui-selected:hover': {
								backgroundColor: `${colors.dropdown.menuItemHover} !important`,
								color: `${colors.dropdown.menuItemHoverText} !important`,
								'& .MuiTypography-root': {  // <span> wrapper inside option
									color: `${colors.dropdown.menuItemHoverText} !important`,
								},
							},
							'&:hover': {
								backgroundColor: `${colors.dropdown.menuItemHover} !important`,
								color: `${colors.dropdown.menuItemHoverText} !important`,
								'& .MuiTypography-root': {  // <span> wrapper inside option
									color: `${colors.dropdown.menuItemHoverText} !important`,
								},
							},
						},
						'& .MuiAutocomplete-noOptions, & .MuiAutocomplete-noOptions *': {
							color: `${colors.dropdown.menuItemText} !important`,
						},

						...((componentsProps?.paper as any)?.sx || {}),
					},
				}
			}}
			popupIcon={popupIcon ?? <ArrowDownIcon />}
			renderInput={
				renderInput ||
				((params) => (
					<CustomTextField
						{...params}
						label={textFieldLabel}
						{...customTextFieldProps}
						InputProps={{ ...params.InputProps, ...customTextFieldProps?.InputProps }}
					/>
				))
			}
		/>
	);
};

export default CustomAutocomplete;
